module.exports = __webpack_public_path__ + "static/media/m-geoshield.a7f65dae.pdf";